import { useRef, useState } from 'react';
import styles from './SuccessIndicators.module.scss';
import VideoControlsOverlay from '../VideoControlsOverlay/VideoControlsOverlay';
import Img from '../Img';

interface IVideoBlockProps {
  isMobile: boolean;
  videoUrl: string;
}

const VideoBlock = ({ isMobile, videoUrl }: IVideoBlockProps) => {
  const [isMuted, setIsMuted] = useState<boolean>(false);
  const [isPlaying, setIsPlaying] = useState<boolean>(!isMobile);
  const [isSpeededUp, setIsSpeededUp] = useState<boolean>(false);
  const [showMobilePreview, setShowMobilePreview] = useState<boolean>(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  const progressRef = useRef<HTMLProgressElement>(null);

  const togglePlay = () => {
    const isPaused = !!videoRef.current?.paused;

    if (!isPaused) {
      videoRef.current?.pause();
    } else {
      videoRef.current?.play();
    }

    setIsPlaying(!isPlaying);
  };

  const toggleSpeed = () => {
    const video = videoRef.current;
    setIsSpeededUp(!isSpeededUp);

    if (video) {
      if (isSpeededUp) {
        video.playbackRate = 1;
      } else {
        video.playbackRate = 2;
      }
    }
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  return (
    <div className={styles.videoBlock}>
      <video
        className={styles.video}
        autoPlay={!isMobile}
        muted={isMuted}
        onLoadedMetadata={() => {
          const duration = videoRef.current?.duration;

          progressRef.current?.setAttribute('max', duration?.toString() || '1');
        }}
        onTimeUpdate={() => {
          const time = videoRef.current?.currentTime;

          progressRef.current?.setAttribute('value', time?.toString() || '0');
        }}
        onPlay={() => {
          setIsPlaying(true);
          setShowMobilePreview(false);
        }}
        onPause={() => {
          setIsPlaying(false);
        }}
        ref={videoRef}
        playsInline
      >
        <source
          src={videoUrl}
          type='video/mp4'
        />
        <track kind='captions' />
      </video>
      <VideoControlsOverlay
        toggleMute={toggleMute}
        togglePlay={togglePlay}
        toggleSpeed={toggleSpeed}
        isMuted={isMuted}
        isPlaying={isPlaying}
        isSpeededUp={isSpeededUp}
        videoRef={videoRef}
      />
      {showMobilePreview && (
      <Img
        width={200}
        height={200}
        className={styles.mobilePreview}
        src='/media/Home/success_indicators_mobile_preview.jpg'
      />
      )}
    </div>
  );
};

export default VideoBlock;
